export default {
  state: {
    currentSignos : {},
  },

  mutations: {

    setCurrentSignos( state, data ){
      state.currentSignos = data
    },

  },

};
